import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateTwitchMembershipsDiscountMutation = createMutationHook(
  MembershipsCreatorApiClient.createTwitchDiscount,
  {
    mutationKey: ['createTwitchMembershipsDiscount'],
  },
)
